export const serverDateToLocaleDateString = (
  serverDate: string | null | undefined,
) => {
  if (!serverDate) return ''

  const date = new Date(serverDate)
  return date.toLocaleDateString()
}

export const serverDateToIsoDateString = (
  serverDate: string | null | undefined,
) => {
  if (!serverDate) return ''

  const date = new Date(serverDate)
  return date.toISOString()
}

export const serverDateToLocaleDateTimeString = (
  serverDate: string | null | undefined,
) => {
  if (!serverDate) return ''

  const date = new Date(serverDate)
  return date.toLocaleString()
}
